<template>
  <keep-alive>
    <div id="editor-container" class="email-builder"></div>
  </keep-alive>
</template>

<script>
export default {
  name: 'EmailBuilder',
  props: {
    design: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      options: {
        id: 'editor-container',
        projectId: 8403,
        displayMode: 'email',
        appearance: { theme: 'light' },
        customJS: [`const branding = document.querySelector('.blockbuilder-branding');console.log(branding);`],
      },
    }
  },
  methods: {
    init() {
      unlayer.init(this.options)
      if (this.design) unlayer.loadDesign(this.design)
    },
    enableAutoSaving() {
      unlayer.addEventListener('design:updated', (updates) => {
        unlayer.exportHtml((data) => {
          this.$emit('onAutoSaving', data)
        })
      })
    },
    removeBranding() {
      const branding = document.querySelector('.blockbuilder-branding')
      console.log(branding)
    },
  },
  beforeCreate() {
    this.$loadScript('//editor.unlayer.com/embed.js')
      .then(() => {
        // Script is loaded
        this.init()
        this.enableAutoSaving()
      })
      .catch((error) => {
        // Failed to fetch script:
        console.error(error)
      })
  },
}
</script>

<style lang="scss" scoped>
.email-builder {
  height: 700px;
}
</style>
